import { cx } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import { ConversationCategoryType } from 'hooks/business/conversationsHooks/useConversationCategory';

const Item = (props: { active: boolean; onClick: () => void; children: React.ReactNode }) => {
  const { active, onClick, children } = props;
  return (
    <button
      className={cx(
        'px-2 py-1 rounded border-none  cursor-pointer flex-1 text-xs',
        active ? 'bg-[#FFFFFF] font-medium text-[#232426]' : 'bg-[transparent] text-[#84868C]',
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

interface ConversationCategoryProps {
  category: ConversationCategoryType;
  onChange: (category: ConversationCategoryType) => void;
}

export const ConversationCategory = (props: ConversationCategoryProps) => {
  const { category, onChange } = props;
  const { t } = useTranslate();

  const options = [
    {
      label: t('conversation.conversationList.tab.mine'),
      value: 'mine',
    },
    {
      label: t('conversation.conversationList.tab.all'),
      value: 'all',
    },
  ] as const;

  return (
    <div className="p-2 border-0 border-b border-solid border-[#F0F2F5]">
      <div className="bg-[#F7F9FA] rounded px-1 py-[3px] flex items-center">
        {options.map((option) => (
          <Item
            key={option.value}
            active={category === option.value}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Item>
        ))}
      </div>
    </div>
  );
};
